import {atom} from 'recoil';
import {recoilPersist} from 'recoil-persist'
import PackageEnum from "../enum/PackageEnum";
import Const from "../constant/Const";

const {persistAtom} = recoilPersist()

export const defaultValue = {
    memberId: "",
    business: false,
    verifyType: null,//VerifyTypeEnum değerlerinden biri olacaktır.
    ticketNumber: null,
    seatNumber: null,
    passcode: null,
    //endpoint uzerinden gelenler
    verifiedTripData: null,
    quotas: null,
    supremePass: false,
    totalMiles: null,
    package: null,
    internetAccessRequest: null,//0 başarılı, 1- 100061, 2- 100019, 3- 99999,
    tcIdentity: null,
    email: null,
    passportNumber: null
}

const userAtom = atom({
    key: 'user',
    default: defaultValue,
    effects_UNSTABLE: [persistAtom],
});

export {userAtom};

export const getUserPackage = (val) => {
    if (val === 'CLSC') return PackageEnum.CLASSIC;
    if (val === 'CLPL') return PackageEnum.CLASSIC_PLUS;
    if (val === 'ELIT') return PackageEnum.ELITE;
    if (val === 'ELPL') return PackageEnum.ELITE_PLUS;
    return null;
}

export const getInternetAccessResponse = (respCode) => {
    if (respCode === undefined || respCode === null) return 0;
    let status = 9;//todo test için 99 yap, prod için 9 olacak
    if (respCode === 100061) {
        status = 1;//popup çıkart "çıkış yap" denilecek. stopInternetAccess çağırılıp login'e yonlenecek.
    } else if (respCode === 100019) {
        status = 2;//bir sorun oluştu tekrar giriş yapmayı deneyiz. direk login sayfasına at.
    } else if (respCode === 99999 || (respCode.toString()?.startsWith("99999") && respCode.toString()?.length === 6)) {
        status = 3;//popup çıkarılıp tekrar dene denilecek
    } else if (respCode === 0)
        status = 0;
    return status;
}

export const isShowWarningDialogPleaseCheckYourDataUsage = () => {
    let warning = localStorage.getItem(Const.WARNING_DIALOG_CHECK_DATA) || null;
    if (warning === undefined || warning === null || warning === false || warning === "false") {
        return false;
    } else {
        localStorage.setItem(Const.WARNING_DIALOG_CHECK_DATA, false);
        return true;
    }
}

export const restartWarningDialogPleaseCheckYourDataUsage = () => {
    localStorage.setItem(Const.WARNING_DIALOG_CHECK_DATA, true);
}

export const isShowFeedback = () => {
    let warning = localStorage.getItem(Const.FEEDBACK_COUNT) || null;
    let total = 0;
    if (warning !== undefined && warning !== null)
        total = parseInt(warning) + 1;
    if (total <= (Const.FEEDBACK_SHOW_COUNT + 1))
        localStorage.setItem(Const.FEEDBACK_COUNT, total);
    return ((warning !== undefined && warning !== null) && total === Const.FEEDBACK_SHOW_COUNT);
}

